const amenities = [
    {
        id: "TV",
        text: "TV",
        icon: "tv_room"
    },
    {
        id: "Internet",
        text: "Internet",
        icon: "internet"
    },
    {
        id: "Aircon",
        text: "Aircon",
        icon: "air_con"
    },
    {
        id: "Closet",
        text: "Closet",
        icon: "closet"
    },
    {
        id: "Washing Machine",
        text: "Washing Machine",
        icon: "washing_machine"
    },
    {
        id: "Inbuilt Kitchen",
        text: "Inbuilt Kitchen",
        icon: "inbuilt_kitchen"
    },
    {
        id: "Guard",
        text: "Guard",
        icon: "guard"
    },
    {
        id: "Renewable Energy",
        text: "Renewable Energy",
        icon: "renewable_energy"
    },
    {
        id: "Security Camera",
        text: "Security Camera",
        icon: "security_camera"
    },
    {
        id: "Swimming Pool",
        text: "Swimming Pool",
        icon: "swimming_pool"
    },
    {
        id: "Water Tank",
        text: "Water Tank",
        icon: "water_tank"
    }
];

export default amenities;
